<template>
  <div v-if="project.accountId === $store.getters.activeWorkspaceId">
    <workspace-project-deletion-modal ref="workspaceProjectDelete"></workspace-project-deletion-modal>
    <b-list-group-item v-bind:key="project.projectId" class="d-flex align-items-center job-list-card">
      <project-image :project="project"></project-image>
      <div class="ml-4 width30 fixed-left" @click="changeRoute(project)">  <span class="project-name">{{ project.name }} </span></div>
      <div class="ml-4">
        <small><strong>Tracked Items: </strong></small><small>{{ project.entitiesCount }}</small><br>
        <small><strong>Space Used: </strong></small><small>{{ project.resourceSize }}</small><br>
        <small><strong>Date Created: </strong></small><small>{{ $moment(project.dateCreated).calendar() }}</small>
      </div>
      <div class="ml-auto">
        <b-button size="sm" variant="outline-danger" class="mx-2 ml-auto" @click="deleteProject(project)">X</b-button>
      </div>
    </b-list-group-item>
  </div>
</template>
<script>
import WorkspaceProjectDeletionModal from '#/ui/Components/Workspace/WorkspaceProjectDeletionModal.vue';
import { UserUpdateDetailedInfoRequest } from '#/protobuf/service_user_pb';
import { UserUpdateInfo } from '#/protobuf/user_pb';
import ProjectImage from './ProjectImage';

export default {
  components: { ProjectImage, WorkspaceProjectDeletionModal },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
  },
  methods: {
    deleteProject(project) {
      this.$refs.workspaceProjectDelete.showDeleteConfirmation(project);
    },
    async changeRoute(project) {
      const request = new UserUpdateDetailedInfoRequest();
      const info = new UserUpdateInfo();
      info.setUserDefaultProject(project.projectId);
      info.setUserDefaultProjectWasUpdated(true);
      request.setInfo(info);
      this.$store.dispatch('user/updateDetails', request).then(() => {
        this.$router.push({ path: '/home', query: { project: project.projectId } });
      });
    },
  },
};
</script>

<style scoped>
a {
  background-color: gray;
  border-radius: 50px;
  padding: 10px;
}

.project-name{
  font-size: medium;
}

.width30{
  min-width: 150px !important;
  cursor: pointer;
}
</style>
